import React from 'react'
import { T, Checkbox } from 'components'
import { useSelector } from 'hooks'
import { membershipType } from 'common/types'
import StyledMembershipCard, { MembershipPrice } from './StyledMembershipCard'

const save = discount =>
  !!discount && (
    <>
      <T label="save" /> {discount}%
    </>
  )

const MembershipCard = ({ membership, selected }) => {
  const { name, price, discount } = membership
  const [value, coins] = price.value.split('.')
  const vipEnabled = useSelector(s => s.siteConfig.features.vipEnabled || s.flags.vip)

  return (
    <StyledMembershipCard selected={selected} vipEnabled={vipEnabled}>
      {vipEnabled ? (
        <>
          <Checkbox checked={selected} readOnly />
          <div className="membership-info">
            <div className="duration">{name}</div>
            <MembershipPrice selected={selected}>
              <div className="currency">{price.currency}</div>
              <div className="value">{value}</div> <div className="coins">{coins}</div>
              <div className="period">
                / <T label="month" />
              </div>
            </MembershipPrice>
          </div>
          <div className="savings savings--top">{save(discount)}</div>
          <div className="savings savings--bottom">{save(discount)}</div>
        </>
      ) : (
        <>
          <div className="duration">{name}</div>

          <div className="body">
            <div className="membership-type">
              <span>
                <T label="membership/gold" /> <T label="membership" />
              </span>

              <div className="savings savings--top">{save(discount)}</div>
            </div>

            <MembershipPrice selected={selected}>
              <div className="currency">{price.currency}</div>
              <div className="value">{value}</div> <div className="coins">{coins}</div>
              <div className="period">
                / <T label="month" />
              </div>
            </MembershipPrice>
            <div className="savings savings--bottom">{save(discount)}</div>
            <T as="div" className="select-plan" label="payment/selectPlan" />
          </div>
        </>
      )}
    </StyledMembershipCard>
  )
}

MembershipCard.propTypes = membershipType

export default MembershipCard
